import * as React from 'react';
import { ChangeEvent, FormEvent } from 'react';
import { Heading } from '../../../../../components/Heading';
import { InfoText } from '../../../../../components/InfoText';
import { Button, TextField } from '@origin-digital/style-guide';
import { HorizontalRule } from 'ts/components/HorizontalRule';

interface EnterUsernameFormViewProps {
  username: string;
  onUsernameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onUsernameBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLButtonElement>) => void;
  spinner: boolean;
  fieldNormalizer: (value: string, previousValue: string) => string;
  inlineErrorMessage: string;
  infoText: string;
}

const EnterUsernameFormView: React.FC<EnterUsernameFormViewProps> = ({
  username,
  onUsernameChange,
  onUsernameBlur,
  onSubmit,
  spinner,
  fieldNormalizer,
  inlineErrorMessage,
  infoText,
}) => {
  return (
    <form noValidate>
      <Heading text="Step 1. Get your code" />
      <InfoText text={infoText} />
      <TextField
        type="email"
        label="Email or mobile number"
        name="username"
        disableIcon={!inlineErrorMessage}
        error={inlineErrorMessage}
        value={username}
        onBlur={onUsernameBlur}
        onChange={onUsernameChange}
        transform={fieldNormalizer}
        helpText="Please enter a valid Australian mobile number or email address"
      />
      <Button
        text="Get my code"
        type="submit"
        name="done"
        onClick={onSubmit}
        block={true}
        spinner={spinner}
      />
      <HorizontalRule />
    </form>
  );
};

export { EnterUsernameFormView };
